import {Injectable, Renderer2, RendererFactory2, ElementRef, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class StylesService {
  private style?: HTMLLinkElement;
  private renderer2: Renderer2;
  private elementRef: ElementRef;
  constructor(private rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
    this.renderer2 = this.rendererFactory.createRenderer(null, null);
  }

  saveState(data: any): void {
    sessionStorage.setItem('usedStyle', JSON.stringify(data));
  }

  restoreState(): any {
    const usedStyle = sessionStorage.getItem('usedStyle');
    return usedStyle ? JSON.parse(usedStyle) : null;
  }

  setDefaultStyle(): void {
    const usedStyle = this.restoreState();
    if (usedStyle) {
      this.setStyle(usedStyle);
    } else {
      const host = window.location.hostname;
      const style = this.getStyleName(host);
      this.setStyle(style);
      this.saveState(style);
    }
  }

  getStyleName(host: string): string {
    switch (true) {
      case host.includes('defro'): // development 'emodul.pl' purpose only
        return 'defro';
      case host.includes('opop'):
        return 'zones';
      case host.includes('jawo'):
        return 'zones';
      case host.includes('kolton'):
        return 'kolton';
      case host.includes('klimor'):
        return 'klimor';
      case host.includes('roth'):
        return 'roth';
      case host.includes('verano'):
        return 'installation';
      case host.includes('emodul.pl'):
        return 'defro';
      case host.includes('emodul.eu'):
        return 'zones';
      default:
        return 'zones';
    }
  }

  setStyle(style: string): void {

    const currentStyle = this.document.querySelector('#style')?.getAttribute('data-currentStyle');
    if (currentStyle !== style) {
      this.saveState(style);
      this.document.querySelector('#style')?.setAttribute('data-currentStyle', style);
      const styleElement = this.document.getElementById('style') as HTMLLinkElement;
      if (styleElement) {
        styleElement.href = `/assets/css/style/${style}.css`;
      }
    }
  }
}
